<template>
    <div id="navBar">
        <nav id="nav">
            <div class="header_catch">
                <img src="../assets/img-header.png" alt="To Be a Good Company ">
            </div>
            <div class="header_content">
                <router-link to="/" class="logo"><img src="../assets/logo.svg" alt="新安東京海上產險"
                                                      @click="iconActive = false"/></router-link>
                <div id="bannerPC" v-if="windowWidth>=1280">
                    <div class="link">
                        <ul id="menu">
                            <li v-for="item in menuList" :key="item.id">
                                <router-link :to="{ path: '/FY24_luckydraw', hash: item.parentUrl }" v-if="item.routerLink === true">{{item.parentName}}</router-link>
                                <router-link :to="item.parentUrl" v-if="item.routerLink === null" @click="routerCheck">{{item.parentName}}</router-link>
                                <router-link :to="item.parentUrl" v-if="item.routerLink === false">{{item.parentName }}</router-link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div id="bannerMobile" v-else>
                    <div class="link">
                        <div class="linkCon" :class="{ 'active': iconActive }">
                            <ul class="menu_m">
                                <li v-for="(item) in menuList" @click="mobileChild(item)" :key="item.id"
                                    :class="{ 'active': item.isActive,'hasChild':item.hasChild !== null }">
                                    <router-link :to="{ path: '/FY24_luckydraw', hash: item.parentUrl }" v-if="item.routerLink">{{item.parentName}}</router-link>
                                    <router-link :to="item.parentUrl" v-if="item.routerLink === null" @click="routerCheck">{{item.parentName}}</router-link>
                                    <router-link :to="item.parentUrl" v-if="item.routerLink === false">{{ item.parentName }}</router-link>
                                </li>
                            </ul>
                        </div>
                        <div class="iconM" @click="iconChange" :class="{ 'active': iconActive }">
                            <div class="bar-top"></div>
                            <div class="bar-middle"></div>
                            <div class="bar-bottom"></div>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    </div>
    <div class="cookie" v-if="showCookieBanner">
        <div class="container">
            <div>為提供您最佳個人化且即時的服務，本網站透過使用Cookie記錄與存取您的瀏覽使用訊息。當您繼續瀏覽(使用)本網站或關閉本視窗，即表示您同意Cookie技術支援。更多資訊請參閱<a href="https://www.tmnewa.com.tw/customize/legalstatement" target="_blank">隱私權保護聲明</a>。</div>
            <button class="btn" @click="checkCookie">我知道了</button>
        </div>
    </div>
</template>
<script setup>
import { ref, reactive, onBeforeMount, onUnmounted } from 'vue';
import Swal from "sweetalert2";
const menuList = reactive([
    { id: "menu1", parentName: "活動內容", parentUrl: '#present', isActive: false, hasChild: null, routerLink: true },
    { id: "menu2", parentName: "抽獎專區", parentUrl: "/FY24_luckydraw/lottery", isActive: false, hasChild: null, routerLink: null },
    { id: "menu3", parentName: "得獎名單", parentUrl: '/lotterypage/detail_winner_list', isActive: false, hasChild: null, routerLink: false },
    { id: "menu4", parentName: "注意事項", parentUrl: "#notice", isActive: false, hasChild: null, routerLink: true },
]);
const iconActive = ref(false);
const windowWidth = ref(window.innerWidth);
const showCookieBanner = ref(false);

const initCookieConsent = () => {
    showCookieBanner.value = localStorage.getItem('cookieConsent') !== 'true';
};

const handleResize = () => {
    windowWidth.value = window.innerWidth;
    if (windowWidth.value >= 1280) {
        iconActive.value = false
    }
};
const iconChange = () => {
    iconActive.value = !iconActive.value;
};
const mobileChild = (item) => {
    item.isActive = !item.isActive
    menuList.forEach(menu => {
        if (menu !== item) {
            menu.isActive = false;
        }
    })

};
const routerCheck = () =>{
    if(localStorage.getItem("jwtInfo") === null){
        Swal.fire({
            showConfirmButton: true,
            showCancelButton: false,
            confirmButtonText: '確定',
            customClass: {
                container: "swal-S",
            },
            html: `<img src="errormark.svg" alt=""><div><h3 class="alertTitle">請先登入</h3><p>登入或註冊會員，之後可前往查詢抽獎次數頁</p></div>`,
        }).then(
            function () {
                document.getElementById('login').scrollIntoView();
                iconActive.value = false;
            },
        );
    }
}

const checkCookie = () => {
    localStorage.setItem('cookieConsent', 'true');
    showCookieBanner.value = false;
};

onBeforeMount(() => {
    window.addEventListener('resize', handleResize);
    handleResize();
    initCookieConsent();
});

onUnmounted(() => {
    window.removeEventListener('resize', handleResize);
})

</script>
<style lang="scss">
.cookie {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: rgba(255, 255, 255, 0.90);
    box-shadow:0 0 24px 0 rgba(0, 0, 0, 0.20);
    z-index: 1000;
    .container{

        padding: 20px 0;
        display: flex;
        justify-content: space-between;
        gap: 20px;

    }
    div {
        font-size: 16px;
        line-height: 150%;
        a {
            color: $blue-600;
            text-decoration: underline;
        }
    }

    .btn {
        background: $blue-700;
        width: 160px;
        min-width: 160px;
        max-width: 160px;
        flex: 0 0 160px;
        height: 40px;
        cursor: pointer;
        margin: 0;
        padding: 0;
    }
    .btn:hover {
        background: $blue-700;
    }
    @media screen and (max-width: $pc) {
        .container {
            padding: 20px;
        }
    }
    @media screen and (max-width: $mobile-small) {
        .container {
            flex-direction: column;
            align-items: flex-start;
            padding: 20px 10px;
        }
        .btn{
            width: 100%;
            min-width: 0;
            max-width: none;
            flex: 1 1 auto;
        }
    }
}

@media only screen and (max-width: $mobile-large) {
    #nav {

        .header_catch img {
            height: 9px !important;
        }


    }
}

#navBar {
    justify-content: center;
    align-items: center;
    position: fixed;
    right: 50%;
    left: 50%;
    transform: translate(-50%, 0);
    top: 0;
    z-index: 1000;
    width: 100%;
    #nav {
        background-color: $white;
        background-position: center top;
        background-repeat: repeat-x;
        border-bottom: 1px solid #ddd;
        z-index: 100;
        box-sizing: border-box;

        .header_catch {
            position: relative;
            width: 100%;
            height: 13px;
            background-image: linear-gradient(to right, #00b3fe, #039);

        }

        .header_catch img {
            position: absolute;
            top: 0;
            right: 0;
            height: 12px;
        }

        .header_content {
            padding: 15px 30px 15px 15px;
            display: flex;
            vertical-align: middle;
            justify-content: space-between;
            align-items: center;
        }


        @media screen and (max-width: $mobile-small) {
            background-color: $white;
            background-position: left bottom;
            background-size: 120%;
        }
        @media screen and (max-width: $pc) {
            padding: 0;
        }

        .container {
            width: $pc;
            display: flex;
            justify-content: space-between;
            vertical-align: middle;
            align-items: center;
            box-sizing: border-box;
            @media screen and (max-width: $pc) {
                width: 95%;
                padding: 0;
            }
        }

        .logo {
            float: left;
            width: 245px;
            height: 52px;

            img {
                display: block;
            }
        }

        .btn {
            padding: 5px 30px;
            width: 132px;
            height: 36px;
            background: $yellow-800;
            color: $white;
            border-radius: 100px;
            font-size: 18px;
            box-sizing: border-box;
            border: 0;
            margin: 0;
        }

    }

    #menu {
        display: flex;

        li {
            //padding: 0 10px;
            border-right: 1px solid #DDD;
            &:last-of-type{border:0}
            a {
                font-weight: 700;
                font-size: 18px;
                cursor: pointer;
                color: $black-800;
                text-decoration: none;

                &:hover {
                    color: $blue-700;
                }
            }
        }

    }

    .menuChild {
        background: #E5EFFA;
        position: absolute;
        left: 0;
        top: 80px;
        width: 100%;
        padding: 5px 0;
        text-align: center;
        z-index: 100;

        .container {
            width: 1024px;
        }

        &.textLeft {
            text-align: justify;
        }

        a {
            color: $black;
            display: inline-block;
            width: 14%;
            text-align: center;
            margin: 5px 0;

            &:hover {
                text-decoration: underline
            }
        }
    }

    .link {
        display: flex;
        text-decoration: none;
    }

    .link a {
        padding: 0 10px;
        cursor: pointer;
        color: $black;

        &:hover {
            color: $blue-700;
        }
    }

    #bannerMobile {
        .link {
            .linkCon {
                opacity: 0;
                background: $white;
                height: 100vh;
                right: -330px;
                position: fixed;
                top: 95px;
                transition: -webkit-transform .5s ease;
                transition: transform .5s ease;
                -webkit-transform: translateX(110%);
                -ms-transform: translateX(110%);
                transform: translateX(110%);
                width: auto;
                padding: 0 20px 20px;
                box-sizing: border-box;
                overflow-y: auto;
                &.active {
                    opacity: 1;
                    -webkit-transform: translateX(-330px);
                    -ms-transform: translateX(-330px);
                    transform: translateX(-330px);
                    min-width: 324px;

                }

                li {
                    margin: 20px 0;
                    cursor: pointer;
                    font-size: 18px;
                    font-weight: 500;

                    &.hasChild {
                        background-image: url("../assets/arrowDown.png");
                        background-repeat: no-repeat;
                        background-position: right top 7px;
                        padding-right: 30px;
                        background-size: 20px;

                        &.active {
                            background-image: url("../assets/arrowUp.png");
                        }
                    }

                    a {
                        color: $black;
                        Text-decoration: none;
                    }

                    a:hover {
                        color: $blue-700;
                    }

                    .child a {
                        font-size: 16px;
                        font-weight: 100;
                    }
                }

            }

            .iconM {
                display: block;
                flex-flow: column wrap;
                justify-content: space-between;
                width: 24px;
                cursor: pointer;

                .bar-bottom, .bar-middle, .bar-top {
                    width: 100%;
                    height: 3px;
                    background: $blue-700;
                    border-radius: 10px;
                    margin: 5px 0;
                    transform-origin: right;
                    transition: all .5s;
                }

                &.active {
                    .bar-top {
                        transform: rotate(-45deg);
                    }

                    .bar-middle {
                        transform: translateX(1rem);
                        opacity: 0;
                    }

                    .bar-bottom {
                        transform: rotate(45deg);
                        position: relative;
                        top: 1px;
                    }
                }
            }

            .menu_m {
                padding: 0 0 60px;
            }
        }
    }

    .slide-enter-active {
        -moz-transition-duration: 0.3s;
        -webkit-transition-duration: 0.3s;
        -o-transition-duration: 0.3s;
        transition-duration: 0.3s;
        -moz-transition-timing-function: ease-in;
        -webkit-transition-timing-function: ease-in;
        -o-transition-timing-function: ease-in;
        transition-timing-function: ease-in;
    }

    .slide-leave-active {
        -moz-transition-duration: 0.3s;
        -webkit-transition-duration: 0.3s;
        -o-transition-duration: 0.3s;
        transition-duration: 0.3s;
        -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
        -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
        -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
        transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
    }

    .slide-enter-to, .slide-leave {
        max-height: 100px;
        overflow: hidden;
    }

    .slide-enter, .slide-leave-to {
        overflow: hidden;
        max-height: 0;
    }

}
</style>
